import SwitchSymbol from 'components/elements/symbols/SwitchSymbol'
import Text from 'components/elements/texts/Text'
import React from 'react'
import styled from 'styled-components'

import ItemLine from './ItemLine'

/**
 * 対象がSwitchLineProps型かチェックする
 * @param target チェック対象
 */
export const isSwitchLineProps = (target: any): target is SwitchLineProps => {
  return target.isSwitched !== undefined && target.label !== undefined
}

/**
 * スイッチ行
 */
const SwitchLine: React.FC<SwitchLineProps> = (props) => {
  return (
    <ItemLine onClick={props.onClick} showLineBorder lineOffset="18px">
      <TextArea>
        <Text>{props.label}</Text>
      </TextArea>
      <SymbolArea>
        <SwitchSymbol isSwitched={props.isSwitched} />
      </SymbolArea>
    </ItemLine>
  )
}

export type SwitchLineProps = {
  isSwitched: boolean
  label: string
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
}

const SymbolArea = styled.div`
  height: 31px;
  margin-right: 16px;
  margin-left: 16px;
`

const TextArea = styled.div`
  flex: 1;
  margin-left: 18px;
`

export default SwitchLine
